/**
 * Created by mac on 2/25/20
 */

const Fogs = function (map2d) {
    cleverapps.EventEmitter.call(this);
    this.map2d = map2d;

    this.wands = 0;

    this.loadConfig();

    this.wantsCalcFogStates = undefined;

    this.blocks = {};
    this.fakeUnits = Fogs.ReadDefaults(map2d.field);

    this.validateUnitsInFogs();
};

Fogs.prototype = Object.create(cleverapps.EventEmitter.prototype);
Fogs.prototype.constructor = Fogs;

Fogs.prototype.load = function (stored) {
    const locationMeta = cleverapps.meta.getLocationMeta(cleverapps.meta.selectedLocationId());

    if (locationMeta.locationType !== "merge") {
        stored = Fogs.fromBit(stored, this.config);
    } else if (typeof stored === "number" || Array.isArray(stored) && stored.length <= Fogs.SYNCED_NUMBERS && typeof stored[0] === "number") {
        stored = Fogs.fromBit(stored, this.config);
    } else if (Array.isArray(stored)) {
        stored = stored.map((fogId) => Fogs.ConvertFromOldName(this.config, fogId));
    }

    const fogRegions = this.getFogRegions();

    const openedFogs = fogRegions.filter(function (type) {
        return this.config[type].opened || stored.indexOf(type) !== -1;
    }, this);

    const unopenedFogs = fogRegions.filter((type) => openedFogs.indexOf(type) === -1, this);

    for (let i = 0; i < openedFogs.length;) {
        const fog = this.config[openedFogs[i]];

        if (fog.available === false || fog.debugMode === true && !cleverapps.config.debugMode) {
            unopenedFogs.push(openedFogs[i]);
            openedFogs.splice(i, 1);
        } else {
            i += 1;
        }
    }

    const regions = this.map2d.regions;

    fogRegions.forEach(function (id) {
        this.config[id].emptyRegion = !regions[id];
    }, this);

    unopenedFogs.forEach((id) => {
        const block = new FogBlock(id, this);

        const region = regions[id];
        if (!region) {
            return;
        }

        this.addBlockTiles(block, region);

        if (cleverapps.config.debugMode && block.isMoney() && !block.options.bubbles) {
            block.tiles.forEach((tile) => {
                let unit = this.fakeUnits[tile.x] && this.fakeUnits[tile.x][tile.y];
                if (unit === undefined) {
                    console.log(`No unit on ${block.id} on x:${tile.x} y:${tile.y}`);
                    return;
                }
                unit = unit.head || unit;
                if (Families[unit.code].units[unit.stage].price === undefined) {
                    alert(`No price for ${unit.code} ${unit.stage}`);
                }
            });
        }
        this.blocks[id] = block;
    });

    Object.values(this.blocks).forEach((block) => {
        block.prepareOpenDelay();
    });
};

Fogs.prototype.getInfo = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(cleverapps.meta.selectedLocationId());

    let info = cleverapps.substract(Object.keys(this.config), Object.keys(this.blocks || {})).filter(function (id) {
        return !this.config[id].emptyRegion;
    }, this);

    if (locationMeta.locationType !== "merge") {
        info = Fogs.toBit(info, this.config);
    } else if (cleverapps.meta.selectedLocationId() === "main") {
        info = info.map((fogId) => Fogs.ConvertToOldName(this.config, fogId));
    } else {
        info = Fogs.toBit(info, this.config);
    }

    return info;
};

Fogs.prototype.setWands = function (amount) {
    this.wands = amount;
    for (const id in this.blocks) {
        this.blocks[id].onChangeWandsAmount(amount);
    }
};

Fogs.prototype.takeWands = function (wands) {
    this.trigger("takeWands", wands);
};

Fogs.prototype.addBlockTiles = function (block, region) {
    const head = region.head || region.positions[0];

    region.positions.sort((a, b) => a.y - b.y || b.x - a.x).forEach((p) => {
        block.add(p.x, p.y, { head: cc.pointEqualToPoint(p, head) });
    });

    this.addBlockBalloon(block, region);
};

Fogs.prototype.getTilesWithDecorators = function (block, fogCellsOnly) {
    const map = this.map2d;
    const used = {};
    const decorTiles = [];

    const buyFogCells = {};
    if (map.regions.buyFogCell) {
        map.regions.buyFogCell.positions.forEach((cell) => {
            buyFogCells[`${cell.x}_${cell.y}`] = 1;
        });
    }
    const fogCellsKeys = block.tiles.map((tile) => map.getPositionKey(tile.x, tile.y));

    const visit = function (tile, firstPass) {
        ISO_NEIGHBORS.concat([Iso.DOWN_BELOW, Iso.HORIZONTAL_LEFT, Iso.HORIZONTAL_RIGHT, Iso.UP_ABOVE]).forEach((dir) => {
            const decorTile = {
                x: tile.x + dir.x,
                y: tile.y + dir.y
            };

            const key = map.getPositionKey(decorTile.x, decorTile.y);
            if (!used[key]) {
                used[key] = true;

                const unit = map.getUnit(decorTile.x, decorTile.y);

                const isBuyFogCell = buyFogCells[`${decorTile.x}_${decorTile.y}`];

                if (firstPass || !unit && !map.isImpassableGround(decorTile.x, decorTile.y) || isBuyFogCell) {
                    if (!fogCellsOnly || (fogCellsOnly && fogCellsKeys.indexOf(key) !== -1)) {
                        decorTiles.push(decorTile);
                    }
                }

                if (isBuyFogCell) {
                    visit(decorTile);
                }
            }
        });
    };

    block.tiles.forEach(visit, true);

    decorTiles.sort((a, b) => b.x - a.x || a.y - b.y);

    return decorTiles;
};

Fogs.prototype.addBlockBalloon = function (block, region) {
    if (region.positions.length > 0 && block.isMoney()) {
        if (!region.balloons) {
            region.balloons = FogBalloon.ChoosePosition(region.positions, region.head);
        }
        if (region.balloons) {
            block.addBalloon(region.balloons.x, region.balloons.y);
        }
    }
};

Fogs.ReadMapUnit = function (item) {
    item = cleverapps.clone(item, true);

    const family = Families[item.code];
    if (!family) {
        if (!Families.DEBUG_ONLY[item.code]) {
            cleverapps.throwAsync(`unknown unit while reading map data ${item.code}`);
        }
        return;
    }

    const data = Families[item.code].units[item.stage];

    item.type = Families[item.code].type;
    item.getType = function () {
        return item.type;
    };

    if (item.grounded !== false && data.source) {
        item.grounded = true;
    }

    if (data.multicell) {
        item.multicell = data.multicell;
    }

    if (data.pointOfInterest) {
        item.pointOfInterest = data.pointOfInterest;
    }

    if (data.important) {
        item.important = data.important;
    }

    item.fresh = true;

    return item;
};

Fogs.ReadDefaults = function (defaults) {
    const units = {};
    defaults.forEach((item) => {
        item = Fogs.ReadMapUnit(item);
        if (!item) {
            return;
        }

        const x = item.x;
        const y = item.y;

        if (units[x] === undefined) {
            units[x] = {};
        }

        if (units[x][y]) {
            if (Array.isArray(units[x][y])) {
                units[x][y].push(item);
            } else {
                units[x][y] = [units[x][y], item];
            }
        } else {
            units[x][y] = item;
        }

        const shape = Unit.GetShape(item);
        if (shape.length > 1 && Unit.MULTY_CELL_BODY_OCCUPIED_CELL) {
            shape.forEach((delta) => {
                if (delta.x || delta.y) {
                    const nx = x + delta.x;
                    const ny = y + delta.y;

                    if (units[nx] === undefined) {
                        units[nx] = {};
                    }

                    units[nx][ny] = {
                        head: item,
                        x: nx,
                        y: ny
                    };
                }
            });
        }
    });
    return units;
};

Fogs.fromBit = function (bit, config) {
    const ids = cleverapps.createSet(cleverapps.fromBit(bit));

    return Object.keys(config).filter((code) => ids[config[code].id], this);
};

Fogs.toBit = function (fogs, config) {
    const ids = fogs.map((fog) => config[fog].id, this);
    return cleverapps.toBit(ids, Fogs.SYNCED_BITS);
};

Fogs.SYNCED_NUMBERS = 2;
Fogs.SYNCED_BITS = cleverapps.SYNCED_BITS * Fogs.SYNCED_NUMBERS;

Fogs.prototype.initStage = function () {
    this.initStageRunned = true;
    this.trigger("initialized");
};

Fogs.prototype.open = function (id, callback, silent) {
    delete this.blocks[id];
    callback = callback || function () {};

    this.map2d.blockedGrounds.updateBlockedGrounds(callback, silent);
    this.map2d.workers && this.map2d.workers.placeNotPositionedWorkers(id);

    this.wantsCalcFogStates = true;

    this.map2d.saveFogs();
    cleverapps.offerManager.refreshByFog(id);

    this.trigger("open");
};

Fogs.prototype.loadConfig = function () {
    this.config = FogsConfig.GetFog(cleverapps.meta.selectedLocationId());
};

Fogs.prototype.getFakeUnits = function (x, y) {
    const units = this.fakeUnits[x] && this.fakeUnits[x][y];
    if (!units) {
        return [];
    }
    return cleverapps.toArray(units);
};

Fogs.prototype.validateUnitsInFogs = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;

    if (!cleverapps.config.debugMode || locationConfig.locationType !== "merge" || locationConfig.isMain) {
        return;
    }

    const config = this.config;
    const regions = this.map2d.regions;

    const fogHeadErrors = [];

    Object.keys(config).forEach((fogId) => {
        const region = regions[fogId];
        if (!region || !region.positions || !region.positions.length) {
            return;
        }

        if (region.head) {
            this.getFakeUnits(region.head.x, region.head.y).forEach((fakeUnit) => {
                if (fakeUnit.grounded) {
                    // that leads to broken bfs on page refresh
                    fogHeadErrors.push(`fog head points to grounded unit ${fogId} ${region.head.x} ${region.head.y} ${fakeUnit.code} ${fakeUnit.stage}`);
                }
            });
        }
    });

    if (fogHeadErrors.length) {
        cleverapps.throwAsync(fogHeadErrors.join("\n"));
    }
};

Fogs.prototype.calcFogStates = function () {
    for (const id in this.blocks) {
        this.blocks[id].calcState();
    }
};

Fogs.prototype.calcFogStatesStage = function () {
    if (this.wantsCalcFogStates && !cleverapps.focusManager.isFocused()) {
        this.wantsCalcFogStates = undefined;
        this.calcFogStates();
    }
};

Fogs.prototype.isOpened = function (fogId) {
    return !this.blocks[fogId];
};

Fogs.prototype.getBlockById = function (fogId) {
    return this.blocks[fogId];
};

Fogs.prototype.findAvailableFogBlock = function () {
    let result;

    for (const id in this.blocks) {
        const block = this.blocks[id];

        if (block.state !== FogBlock.UNAVAILABLE) {
            if (!result || result.state < block.state) {
                result = block;
            }
        }
    }
    return result;
};

Fogs.prototype.showBalloons = function (silent) {
    for (const i in this.blocks) {
        this.blocks[i].showBalloon(silent);
    }
};

Fogs.prototype.hideBalloons = function () {
    for (const i in this.blocks) {
        this.blocks[i].hideBalloon();
    }
};

Fogs.prototype.findBlockWithProgress = function () {
    return Object.values(this.blocks).filter((block) => block.state === FogBlock.CANTOPEN && !block.canOpen() && !block.isMoney() && !block.isSpecial()).sort((a, b) => a.getOpenPrice() - b.getOpenPrice())[0];
};

Fogs.prototype.findFogReadyToOpen = function () {
    for (const i in this.blocks) {
        const fogBlock = this.blocks[i];
        if (fogBlock.options.available !== false && fogBlock.state === FogBlock.CANOPEN
            && !fogBlock.isMoney() && fogBlock.canOpen() && fogBlock.isReady()) {
            return this.blocks[i];
        }
    }
};

Fogs.prototype.findTile = function (x, y) {
    for (const i in this.blocks) {
        const fogBlock = this.blocks[i];
        const tile = fogBlock.findTile(x, y);
        if (tile) {
            return tile;
        }
    }
};

Fogs.prototype.findFakeUnit = function (targetUnit) {
    for (const row in this.fakeUnits) {
        for (const col in this.fakeUnits[row]) {
            const fakeUnits = this.getFakeUnits(row, col);
            for (let i = 0; i < fakeUnits.length; i++) {
                if (Unit.IsApplicable(targetUnit, fakeUnits[i])) {
                    return fakeUnits[i];
                }
            }
        }
    }
};

Fogs.prototype.listFakeUnits = function (filter) {
    if (filter && typeof filter !== "function") {
        filter = Unit.IsApplicable.bind(Unit, filter);
    }

    const units = [];

    for (const row in this.fakeUnits) {
        for (const col in this.fakeUnits[row]) {
            cleverapps.toArray(this.fakeUnits[row][col]).forEach((fakeUnit) => {
                if (!fakeUnit.head && (!filter || filter(fakeUnit))) {
                    units.push(fakeUnit);
                }
            });
        }
    }

    return units;
};

Fogs.prototype.getFakeUnit = function (x, y) {
    const result = this.fakeUnits[x] && this.fakeUnits[x][y];
    if (result && Array.isArray(result)) {
        return result[0];
    }
    return result;
};

Fogs.prototype.getFogRegions = function () {
    return Object.keys(this.config);
};

Fogs.prototype.isPresentOnMap = function (unit) {
    if (!this.presentedUnits) {
        const presentedUnits = {};

        for (const row in this.fakeUnits) {
            for (const col in this.fakeUnits[row]) {
                if (!this.fakeUnits[row][col].head) {
                    presentedUnits[Unit.GetKey(this.getFakeUnit(row, col))] = true;
                }
            }
        }

        this.presentedUnits = presentedUnits;
    }

    return this.presentedUnits[Unit.GetKey(unit)];
};

Fogs.ConvertFromOldName = function (fogsConfig, fogId) {
    if (fogsConfig[fogId]) {
        return fogId;
    }

    for (const id in fogsConfig) {
        const fogConfig = fogsConfig[id];
        if (fogConfig && fogConfig.oldName && fogConfig.oldName === fogId) {
            return id;
        }
    }
};

Fogs.ConvertToOldName = function (fogsConfig, fogId) {
    const fogConfig = fogsConfig[fogId];
    return fogConfig && fogConfig.oldName || fogId;
};
